import BaseEntity from '../base/BaseEntity.model';

export default class TipoTramiteDocumento extends BaseEntity {
    public tipoDocumentoNombre?:string;
    constructor(
        public tipoDocumentoId?: number,
        public requerido?: boolean,
        public tipoTramiteId?: number
    ) {
        super();
    }
}